"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rest_api_1 = require("@nimles/rest-api");

var actionTypes_1 = require("../actionTypes");

var actionCreator_1 = require("../../utils/actionCreator");

exports.setTenantId = function (tenantId) {
  return function (dispatch) {
    dispatch({
      type: actionTypes_1.SET_TENANT,
      id: tenantId
    });
  };
};

exports.setClientId = function (tenantId) {
  return function (dispatch) {
    dispatch({
      type: actionTypes_1.SET_CLIENT,
      id: tenantId
    });
  };
};

exports.signInUser = function (user) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.SIGNIN_USER
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var _b, accessToken, refreshToken, jwt;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!auth.clientId) {
              // todo handle this
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , rest_api_1.signIn(auth.clientId, user)];

          case 1:
            _b = _c.sent(), accessToken = _b.accessToken, refreshToken = _b.refreshToken;
            jwt = actionCreator_1.parseJwt(accessToken);

            if (!accessToken || !refreshToken) {
              console.error('Missing access token or refresh token');
              return [2
              /*return*/
              ];
            }

            return [2
            /*return*/
            , {
              data: {
                accessToken: accessToken,
                refreshToken: refreshToken,
                expires: jwt.exp
              }
            }];
        }
      });
    });
  }, undefined, {
    disableRefreshTokens: true
  });
};

exports.refreshUserTokens = function () {
  return actionCreator_1.apiAction({
    type: actionTypes_1.REFRESH_USER_TOKENS
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      var _b, accessToken, refreshToken, jwt;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            if (!auth.clientId || !auth.refreshToken) {
              // todo handle this
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , rest_api_1.refreshTokens(auth.clientId, auth.refreshToken)];

          case 1:
            _b = _c.sent(), accessToken = _b.accessToken, refreshToken = _b.refreshToken;
            jwt = actionCreator_1.parseJwt(accessToken);

            if (!accessToken || !refreshToken) {
              console.error('Missing access token or refresh token');
              return [2
              /*return*/
              ];
            }

            return [2
            /*return*/
            , {
              data: {
                accessToken: accessToken,
                refreshToken: refreshToken,
                expires: jwt.exp
              }
            }];
        }
      });
    });
  }, undefined, {
    disableRefreshTokens: true
  });
};

exports.signOutUser = function () {
  return {
    type: actionTypes_1.SIGNOUT_USER
  };
};

exports.forgotPassword = function (username) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.FORGOT_PASSWORD
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!auth.tenantId) {
              // todo handle this
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , rest_api_1.postForgotPassword(auth.tenantId, username)];

          case 1:
            _b.sent();

            return [2
            /*return*/
            , {
              data: {}
            }];
        }
      });
    });
  }, undefined, {
    disableRefreshTokens: true
  });
};

exports.resetPassword = function (password, code) {
  return actionCreator_1.apiAction({
    type: actionTypes_1.RESET_PASSWORD
  }, function (_a) {
    var auth = _a.auth;
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            if (!auth.tenantId) {
              // todo handle this
              return [2
              /*return*/
              ];
            }

            return [4
            /*yield*/
            , rest_api_1.postResetPassword(auth.tenantId, password, code)];

          case 1:
            _b.sent();

            return [2
            /*return*/
            , {
              data: {}
            }];
        }
      });
    });
  }, undefined, {
    disableRefreshTokens: true
  });
};